<img class="h-max-60" :src="imgUrl">